// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35Ox-","option":"styles_option__3kQ2n","active":"styles_active__2Yvx5"};